import styled from 'styled-components';

export const Wrapper = styled.div`
  color: ${({ theme }) => theme.palette.neutral.neutral100};
  font-size: ${({ theme }) => theme.fontSize[2]}px;
  margin: 0 0 0.5rem;
`;
